
import { StorageManager } from "./storage-manager.js";

export const localConfigStorage = new StorageManager("rxdb-chat-local-config");
